<div class="main-wrapper">
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">{{'loading.moment' | translate}}</p>
    </ngx-spinner>

    <div class="successfull-container">
        <!-- Logo and Icon -->
        <div class="successfull-center">
            <img src="../../../assets/svg/atoms-icon-box.svg" alt="Success" loading="lazy">
            <h2>{{'loading.checking-info' | translate}}</h2>
            <p>{{'loading.patience' | translate}}</p>
        </div>
    </div>
</div>